import React from 'react';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { HyperlinkTarget } from '../../../components/atoms/Hyperlink';
import { FavoriteItem } from '../FavoritePagesTypes';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export function PageFavoriteExternalLink(item: FavoriteItem) {
  const { t } = useSonTranslation('phrases');

  return (
    <ContentLink
      external
      newWindowIndicator
      target={HyperlinkTarget.BLANK}
      key={item.id}
      to={item.content.pageLink.url}
      title={t('linkOpensInNewWindow')}
      tooltipPlacement={TooltipPlacement.TOP}
    >
      {item.content.pageLink.name}
    </ContentLink>
  );
}
